import React from "react";
import { AppSettingService } from "../../../_service";
import { useQuery } from "react-query";
import { NavLink, useNavigate } from "react-router-dom";

import "./style.css";
import { CustomButton } from "../../../components/customButton";
import { Loader } from "../../../components";
import { MdDragIndicator } from "react-icons/md";
import { FaInfoCircle } from "react-icons/fa";

const AddCustomItems = () => {
  const navigate = useNavigate();
  const { data, isLoading } = useQuery("_repoData", () =>
    AppSettingService._getCustomInput(),
  );

  return (
    <div>
      {isLoading && <Loader />}
      <h1 style={{ color: "#476575", marginBottom: "1rem" }}>
        Add New Custom Item
      </h1>
      <div style={{ display: "flex", gap: "10px" }}>
        <div>
          <p style={{ marginBottom: '0.5rem' }}>Select type of custom item to add:</p>
          <ul
            style={{ marginLeft: "2rem", flexDirection: "column" }}
            className="payslip-container"
          >
            {(data?.data?.data?.input_items || []).map((item: any) => {
              return (
                item.item_code !== "benefit" && (
                  <li
                    key={item?.item_code}
                    style={{ margin: ".1rem", fontWeight: "bold" }}
                  >
                    <NavLink
                      className="data card-row-link"
                      to={`/dashboard/add-item-fields/${item?.item_code}`}
                      state={item?.item_name}
                      style={{ backgroundColor: "transparent", padding: 0 }}
                    >
                      {item?.item_name}
                    </NavLink>
                  </li>
                )
              );
            })}
          </ul>
        </div>
        <div style={{
          padding: '1rem',
          borderRadius: '8px',
          fontSize: '0.9rem',
          backgroundColor: '#f0f9ff',
          borderLeft: '4px solid #3b82f6',
          margin: '0 2rem',
          height: 'fit-content'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '0.75rem',
            marginBottom: '0.5rem'
          }}>
            <FaInfoCircle style={{
              color: '#3b82f6',
              fontSize: '1.1rem',
              flexShrink: 0,
              marginTop: '0.1rem'
            }} />
            <strong style={{
              color: '#1e40af',
              fontSize: '0.95rem'
            }}>Important Note</strong>
          </div>

          <ol style={{
            margin: 0,
            paddingLeft: '2rem',
            color: '#374151',
            lineHeight: '1.5'
          }}>
            <li style={{ marginBottom: '0.25rem' }}>
              <span style={{ fontWeight: '500' }}>"Name" field in all categories are unique.</span>
            </li>
            <li>
              <span style={{ fontWeight: '500' }}>"Name" field in one category is unique and the same "Name" cannot be used in other categories.</span>
            </li>
          </ol>
        </div>
      </div>
      {/* <div className="payslip-container">
        <span style={{ backgroundColor: "transparent", marginTop: "1rem" }}>
          or create a {"  "}
          <NavLink
            className="data card-row-link"
            to={`/dashboard/add-item-fields/copy-of-system-item`}
            state={"Item (Copy of System Item"}
            style={{
              backgroundColor: "transparent",
              padding: 0,
              fontWeight: "bold",
            }}
          >
            copy of an existing system item.
          </NavLink>
        </span>
      </div> */}
      <CustomButton
        title="Cancel"
        onClick={() => {
          // navigate("/dashboard/app-settings/custom-items");
          navigate(-1);
        }}
        type="secondary"
        styles={{
          marginTop: '1rem'
        }}
      />
    </div>
  );
};

export default AddCustomItems;
